// Shared tooltip styling for small inline tooltips used across the app.
// Currently used by RowOfMessageInteractionIcons and CopyButtonInBox.

export const inlineTooltipStyle = {
  position: 'absolute',
  top: '-4px',
  left: '100%',
  marginLeft: 4,
  width: 'fit-content',
  background: 'rgba(255, 255, 255, 0.9)',
  color: '#000',
  borderRadius: '3px',
  padding: '4px 8px',
  fontSize: '0.8rem',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
  zIndex: 10,
};
